<button class="fcp-floating-button">
    <fcp-icon [icon]="iconName" class="fcp-floating-button-icon"></fcp-icon>
</button>
